import { SortDirection } from '@tanstack/react-table';
import { NavArrowDownSolid, NavArrowUpSolid } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { TABLE_ORDER } from './DatatableCore.types';

interface TableOrderProps {
  order: false | SortDirection;
}

const Order: FunctionComponent<TableOrderProps> = ({ order }) => {
  return (
    <>
      {order === TABLE_ORDER.ASC && <NavArrowUpSolid width={15} height={15} />}
      {order === TABLE_ORDER.DESC && (
        <NavArrowDownSolid width={15} height={15} />
      )}
    </>
  );
};

export default Order;
